import { DashboardConfig } from '@litlingo/client';

const emptyDefaultDashboardConfig: DashboardConfig = {
  filters: [],
  widgets: [],
  primary_timezone: 'America/Chicago',
};

export default emptyDefaultDashboardConfig;
